import {
  createEventObject,
  draggableFormItems,
  EventState,
  EventStateResponse,
  registerObject,
  postLink,
  postLinkResponse,
  suggestionLinkResponse,
  eventObject,
  eventParticipant,
  TableParticipant,
  EventSettingsResponse,
  DbKeyValues,
  MailKeyValues,
  DbKey,
  MailKey,
  formInputInfo,
  SubEventCreateResponse,
} from "../types/types";
import { LoopReducer, loop, Loop, Cmd } from "redux-loop";
import {
  getType,
  createAsyncAction,
  ActionType,
  createAction,
} from "typesafe-actions";
import eventService from "../services/events";
import formService from "../services/forms";
import { historyService } from "../services/historyService";
import ConsoleHelper from "../utils/logger";
import {
  arrayToObject,
  getParticipantTableStartingHeaders,
} from "../utils/functions";
import storeService from "../services/storage";
import { checkLoading } from "./listEvents/listEventsReducer";

const initialState: EventState = {
  initLoading: false,
  eventFetched: false,
  customerId: "",
  eventId: "",
  eventName: "",
  eventState: "",
  subEventFormId: "",
  subEventId: "",
  subEventName: "",
  subEventState: "",
  subEventCreateState: {
    eventPage: false,
    selectRegistration: true,
    createRegistration: false,
  },
  registrationState: {
    type: "",
    registrationQuestions: {
      baskets: {},
      items: [],
    },
    subEventInfo: {
      subEventMaxRegistrants: "",
      subEventStartTime: null,
      subEventEndTime: null,
      subEventRegistrationEnd: null,
      subEventRegistrationStart: null,
      subEventUpdateEnd: null,
      subEventCancelEnd: null,
      subEventName: null,
      subEventType: null,
      subEventSupportEmail: null,
      subEventSupportInstruction: null,
      subEventSupportPhone: null,
      subEventAllowCancel: 0,
      subEventAllowModify: 0,
      subEventMaxGroupSize: 0,
      subEventAllowedQue: 0,
      subEventAllowGroupEdit: 0,
    },
    pageStyling: {
      styleId: null,
      backgroundColor: null,
      logoUrl: null,
    },
    pageMessages: {
      pageId: null,
      pageHeader: "",
      pageDescription: "",
      pageThankYouHeader: "Thank you",
      pageThankYouText: "Thank you for registering!",
      pageRegistrationFullHeader: "Full",
      pageRegistrationFullText:
        "Unfortunately registration for this event is full",
      pageregistrationNotYetOpenHeader: "Registration has not begun",
      pageregistrationNotYetOpenText:
        "Registration for this event has not yet began",
      pageregistrationEndedHeader: "Ended",
      pageregistrationEndedText:
        "Unfortunately registration for this event has already ended",
    },
    link: {
      link: null,
      linkPrefix: null,
      linkSuggestion: null,
      linkId: null,
    },
    dbKeys: {
      dbKeys: [],
      mailKeys: [],
    },
  },
  eventDetails: {
    eventName: "",
    eventOrganiser: "",
    eventPlace: "",
    eventStreetAddress: "",
    eventZip: "",
    eventCity: "",
    eventCountry: "",
    eventStartDate: "",
    eventEndDate: "",
    eventWebPage: "",
    eventDescription: "",
    eventInfoText: "",
    eventHelpText: "",
    supportEmail: "",
    supportInstruction: "",
    supportPhone: "",
  },
  eventPage: {
    subEventFilter: null,
  },
};

export const getDraggableForm = createAsyncAction(
  "START_REGISTRATION_FORM_FETCH",
  "FETCH_COMPLETE",
  "FETCH_FAIL"
)<{ form: string; language: string }, { data: any; status: number }, Error>();

export const getDbKeys = createAsyncAction(
  "START_DB_KEYS_FETCH",
  "DB_KEYS_FETCH_COMPLETE",
  "DB_KEYS_FETCH_FAIL"
)<undefined, { data: EventSettingsResponse; status: number }, Error>();

export const getEventAsync = createAsyncAction(
  "START_EVENTSTATE_FETCH",
  "EVENTSTATE_FETCH_COMPLETE",
  "EVENTSTATE_FETCH_FAIL"
)<string, { data: EventStateResponse; status: number }, Error>();

export const sendRegistrationAsync = createAsyncAction(
  "START_REGISTRATION_SELECT_REQUEST",
  "REGISTRATION_REQUEST_COMPLETE",
  "REGISTRATION_REQUEST_FAIL"
)<registerObject, { data: any; status: number; url: string }, Error>();

export const createEventAsync = createAsyncAction(
  "START_EVENT_CREATE_REQUEST",
  "CREATE_EVENT_REQUEST_COMPLETE",
  "CREATE_EVENT_REQUEST_FAIL"
)<createEventObject, { data: any; status: number }, Error>();

export const createSubEventAsync = createAsyncAction(
  "START_CREATE_SUBEVENT_REQUEST",
  "CREATE_SUBEVENT_REQUEST_COMPLETE",
  "CREATE_SUBEVENT_REQUEST_FAIL"
)<string, { data: SubEventCreateResponse; status: number }, Error>();

export const saveRegistrationQuestions = createAsyncAction(
  "START_SAVE_REGISTRATION_QUESTIONS_REQUEST",
  "SAVE_REGISTRATION_QUESTIONS_COMPLETE",
  "SAVE_REGISTRATION_QUESTIONS_FAIL"
)<formInputInfo[], { data: any; status: number }, Error>();

export const getEventDetails = createAsyncAction(
  "START_GET_EVENT_DETAILS_REQUEST",
  "GET_EVENT_DETAILS_COMPLETE",
  "GET_EVENT_DETAILS_FAIL"
)<string, { data: any; status: number }, Error>();

export const postLinkForm = createAsyncAction(
  "START_POST_LINK_FORM",
  "POST_LINK_FORM_COMPLETE",
  "POST_LINK_FORM_FAIL"
)<postLink, { data: postLinkResponse; status: number }, Error>();

export const getLinkSuggestion = createAsyncAction(
  "START_GET_LINK_SUGGESTION",
  "GET_LINK_SUGGESTION_COMPLETE",
  "GET_LINK_SUGGESTION_FAIL"
)<undefined, { data: suggestionLinkResponse; status: number }, Error>();

export const getParticipantDetails = createAsyncAction(
  "START_PARTICIPANT_DETAILS_FETCH",
  "PARTICIPANT_DETAILS_FETCH_COMPLETE",
  "PARTICIPANT_DETAILS_FETCH_FAIL"
)<
  { subEventId: string; uuid: string },
  { data: any; status: number; eventId: string },
  Error
>();

export const getSubEventDetails = createAsyncAction(
  "START_SUBEVENT_DETAILS_FETCH",
  "SUBEVENT_DETAILS_COMPLETE",
  "SUBEVENT_DETAILS_FAIL"
)<string, { data: any; status: number }, Error>();

const changeCreateState = createAction("CHANGECREATESTATE")<{
  key: string;
  value: boolean;
}>();
const changeRegistrationInfo = createAction("CHANGEREGISTRATIONINFO")<{
  nestedKey: string;
  key: string;
  value: string;
}>();
const changeRegistrationInfoDate = createAction("CHANGEREGISTRATIONINFODATE")<{
  key: string;
  value: Date;
}>();
const updateRegistrationInfo = createAction("UPDATEREGISTRATIONINFO")<{
  key: string;
  value: string;
}>();
const setRegistrationQuestions = createAction(
  "SETREGISTRATIONQUESTIONS"
)<draggableFormItems>();
const setEventDetails = createAction("SET_EVENT_DETAILS")<{
  details: createEventObject;
  subEventId?: string;
}>();
const changePageStyling = createAction("CHANGEPAGESTYLING")<{
  nestedKey: string;
  key: string;
  value: string;
}>();

type Action =
  | ActionType<typeof getEventAsync>
  | ActionType<typeof sendRegistrationAsync>
  | ActionType<typeof getDraggableForm>
  | ActionType<typeof createEventAsync>
  | ActionType<typeof createSubEventAsync>
  | ActionType<typeof saveRegistrationQuestions>
  | ActionType<typeof getEventDetails>
  | ActionType<typeof postLinkForm>
  | ActionType<typeof getLinkSuggestion>
  | ActionType<typeof getDbKeys>
  | ActionType<typeof getParticipantDetails>
  | ActionType<typeof getSubEventDetails>
  | ActionType<typeof changeCreateState>
  | ActionType<typeof changeRegistrationInfo>
  | ActionType<typeof updateRegistrationInfo>
  | ActionType<typeof changeRegistrationInfoDate>
  | ActionType<typeof setRegistrationQuestions>
  | ActionType<typeof setEventDetails>
  | ActionType<typeof changePageStyling>;

export const eventReducer: LoopReducer<EventState, Action> = (
  state = initialState,
  action: Action
): EventState | Loop<EventState> => {
  switch (action.type) {
    // get one event
    case getType(getEventAsync.request):
      return loop(
        state,
        Cmd.run(eventService.getEventState, {
          successActionCreator: getEventAsync.success,
          failActionCreator: getEventAsync.failure,
          args: [action.payload],
        })
      );

    case getType(getEventAsync.success):
      ConsoleHelper("here", action.payload.data.createState);
      if (action.payload.status === 200) {
        const subEventCreateState =
          action.payload.data.createState.length > 1
            ? {
                eventPage: true,
                createRegistration: false,
                selectRegistration: false,
              }
            : action.payload.data.createState[0].subEventCreateState;

        return {
          ...state,
          subEventCreateState,
          customerId: action.payload.data.createState[0].customerId,
          eventId: action.payload.data.createState[0].eventId,
          eventName: action.payload.data.createState[0].eventName,
          eventState: action.payload.data.createState[0].eventState,
          subEventId: action.payload.data.createState[0].subEventId,
          subEventFormId: action.payload.data.createState[0].subEventFormId,
          subEventName: action.payload.data.createState[0].subEventName,
          subEventState: action.payload.data.createState[0].subEventState,
          registrationState: {
            //Tänne lisätä muita defaultteja?
            ...state.registrationState,
            subEventInfo: {
              ...state.registrationState.subEventInfo,
              subEventName: state.eventDetails.eventName,
              subEventStartTime: state.eventDetails.eventStartDate,
              subEventEndTime: state.eventDetails.eventEndDate,
            },
            pageMessages: {
              ...state.registrationState.pageMessages,
              pageHeader: action.payload.data.createState[0].eventName,
              pageDescription: state.eventDetails.eventDescription,
            },
            pageStyling: {
              ...state.registrationState.pageStyling,
              backgroundColor:
                action.payload.data.customerSettings.eventCreation.pageStyling
                  .backgroundColor,
              logoUrl:
                action.payload.data.customerSettings.eventCreation
                  .linkCustomerPrefix,
            },
            link: {
              linkSuggestion: null,
              link: null,
              linkId: null,
              linkPrefix:
                action.payload.data.customerSettings.eventCreation
                  .linkCustomerPrefix,
            },
          },
        };
      } else {
        ConsoleHelper("could not get event state");
        return state;
      }

    //get draggableForm
    case getType(getDraggableForm.request):
      return loop(
        { ...state, initLoading: true },
        Cmd.run(formService.getDraggableForm, {
          successActionCreator: getDraggableForm.success,
          failActionCreator: getDraggableForm.failure,
          args: [action.payload],
        })
      );

    case getType(getDraggableForm.success):
      if (action.payload.status === 200) {
        return loop(
          {
            ...state,
            registrationState: {
              ...initialState.registrationState,
              subEventInfo: {
                ...initialState.registrationState.subEventInfo,
                subEventName: state.eventDetails.eventName,
                subEventStartTime: state.eventDetails.eventStartDate,
                subEventEndTime: state.eventDetails.eventEndDate,
                subEventSupportEmail: state.eventDetails.supportEmail,
                subEventSupportPhone: state.eventDetails.supportPhone,
                subEventSupportInstruction:
                  state.eventDetails.supportInstruction,
              },
              registrationQuestions: {
                baskets: action.payload.data.formData.baskets,
                items: action.payload.data.formData.inputs,
              },
              pageMessages: {
                ...initialState.registrationState.pageMessages,
                pageHeader: state.eventDetails.eventName,
                pageDescription: state.eventDetails.eventDescription,
              },
            },
          },
          Cmd.action({ type: "START_DB_KEYS_FETCH" })
        );
      }
      ConsoleHelper("could not get information");
      ConsoleHelper(action.payload.status);
      return { ...state, initLoading: false };

    case getType(getDbKeys.request):
      ConsoleHelper("getting db keys");
      return loop(
        state,
        Cmd.run(eventService.getDbKeys, {
          successActionCreator: getDbKeys.success,
          failActionCreator: getDbKeys.failure,
        })
      );

    case getType(getDbKeys.success):
      return {
        ...state,
        initLoading: false,
        registrationState: {
          ...state.registrationState,
          dbKeys: {
            mailKeys: action.payload.data.mailKeys,
            dbKeys: action.payload.data.dbKeys,
          },
        },
      };

    case getType(getDbKeys.failure):
      ConsoleHelper("failed to get event settings (db keys)");
      return { ...state, initLoading: false };

    case getType(getSubEventDetails.request):
      ConsoleHelper("getting subevent details");
      return loop(
        state,
        Cmd.run(eventService.getSubEventDetails, {
          successActionCreator: getSubEventDetails.success,
          failActionCreator: getSubEventDetails.failure,
          args: [action.payload],
        })
      );

    case getType(getSubEventDetails.success):
      return {
        ...state,
        initLoading: false,
        registrationState: action.payload.data.registrationState,
      };

    case getType(getSubEventDetails.failure):
      ConsoleHelper("failed to get subevent details");
      return { ...state, initLoading: false };

    //send registration
    case getType(sendRegistrationAsync.request):
      ConsoleHelper("in reducer start of loop");
      const url = action.payload.registerName.startsWith("CM-Registration")
        ? `/events/${action.payload.eventId}/subevents/${action.payload.subEventId}/registration`
        : `/events/${action.payload.eventId}`;
      return loop(
        state,
        Cmd.run(eventService.saveRegister, {
          successActionCreator: sendRegistrationAsync.success,
          failActionCreator: sendRegistrationAsync.failure,
          args: [action.payload, url],
        })
      );

    case getType(sendRegistrationAsync.failure):
      return state;

    case getType(sendRegistrationAsync.success):
      ConsoleHelper("in reducer success");
      ConsoleHelper(action.payload.data);
      return loop(
        {
          ...state,
          subEventCreateState: {
            eventPage: false,
            createRegistration: true,
            selectRegistration: false,
          },
        },
        Cmd.run(historyService.goto, {
          args: [action.payload.url],
        })
      );
    //create event
    case getType(createEventAsync.request):
      ConsoleHelper("in reducer start of loop");
      return loop(
        {
          ...state,
          eventDetails: action.payload,
        },
        Cmd.run(eventService.create, {
          successActionCreator: createEventAsync.success,
          failActionCreator: createEventAsync.failure,
          args: [action.payload],
        })
      );

    case getType(createEventAsync.success):
      ConsoleHelper("in reducer success");
      ConsoleHelper("created new event");
      ConsoleHelper(action.payload.data);
      if (action.payload.status === 200) {
        return loop(
          {
            ...state,
            customerId: action.payload.data.customerId,
            subEventId: action.payload.data.subEventId,
            eventId: action.payload.data.eventId,
            eventName: action.payload.data.eventName,
            eventState: action.payload.data.eventState,
            subEventCreateState: action.payload.data.subEventCreateState,
            subEventFormId: action.payload.data.subEventFormId,
            subEventName: action.payload.data.subEventName,
            subEventState: action.payload.data.subEventState,
          },
          Cmd.run(historyService.goto, {
            args: [`events/${action.payload.data.eventId}`],
          })
        );
      } else {
        return loop(state, Cmd.run(createEventAsync.failure, {}));
      }
    //createSubEvent
    case getType(createSubEventAsync.request):
      return loop(
        { ...state, initLoading: true },
        Cmd.run(eventService.createSubEvent, {
          successActionCreator: createSubEventAsync.success,
          failActionCreator: createSubEventAsync.failure,
          args: [action.payload],
        })
      );

    case getType(createSubEventAsync.success):
      ConsoleHelper("created subevent");
      ConsoleHelper(action.payload.data);
      if (action.payload.status === 200) {
        return loop(
          {
            ...state,
            initLoading: false,
            subEventId: action.payload.data.subEventId,
            subEventFormId: action.payload.data.subEventFormId,
            subEventState: action.payload.data.subEventState,
            subEventName: action.payload.data.subEventName,
          },
          Cmd.list([
            Cmd.action({
              type: "START_EVENTS_FETCH",
              payload: { date: "0", limit: "0" },
            }),
            Cmd.run(historyService.goto, {
              args: [
                `/events/${action.payload.data.eventId}/subevents/${action.payload.data.subEventId}`,
              ],
            }),
          ])
        );
      } else {
        ConsoleHelper("could not create subevent");
        ConsoleHelper(action.payload.status);
        return { ...state, initLoading: false };
      }

    case getType(createSubEventAsync.failure):
      return { ...state, initLoading: false };

    //get event details
    case getType(getEventDetails.request):
      return loop(
        { ...state, initLoading: true },
        Cmd.run(eventService.getEventDetails, {
          successActionCreator: getEventDetails.success,
          failActionCreator: getEventDetails.failure,
          args: [action.payload],
        })
      );

    case getType(getEventDetails.success):
      ConsoleHelper("got event details");
      ConsoleHelper(action.payload.data);
      if (action.payload.status === 200) {
        return {
          ...state,
          initLoading: false,
          eventFetched: true,
          eventDetails: {
            ...state.eventDetails,
            eventName: action.payload.data.eventName,
            eventPlace: action.payload.data.eventPlace,
            eventStreetAddress: action.payload.data.eventStreetAddress,
            eventZip: action.payload.data.eventZip,
            eventCity: action.payload.data.eventCity,
            eventCountry: action.payload.data.eventCountry,
            eventWebPage: action.payload.data.eventWebPage,
            eventStartDate: action.payload.data.eventStartDate,
            eventEndDate: action.payload.data.eventEndDate,
          },
        };
      } else {
        ConsoleHelper("could not get information");
        ConsoleHelper(action.payload.status);
        return { ...state, initLoading: false };
      }

    case getType(getEventDetails.failure):
      return { ...state, initLoading: false };

    case getType(saveRegistrationQuestions.request):
      ConsoleHelper("in reducer start of loop");
      const formLanguage = storeService.getString("language") || "fi";
      const object = {
        eventId: state.eventId,
        registrationQuestions: action.payload,
        formLanguage,
        formPrivacy: "customer",
        registrationState: state.registrationState,
        subEventCreateState: state.subEventCreateState,
        subEventFormId: state.subEventFormId,
        subEventId: state.subEventId,
        subEventName: state.subEventName,
        subEventState: state.subEventState,
      };
      return loop(
        { ...state, initLoading: true },
        Cmd.run(eventService.saveEventRegistrationQuestions, {
          successActionCreator: saveRegistrationQuestions.success,
          failActionCreator: saveRegistrationQuestions.failure,
          args: [object],
        })
      );
    case getType(saveRegistrationQuestions.failure):
      return { ...state, initLoading: false };

    case getType(saveRegistrationQuestions.success):
      //TODO: Tänne kenties looppi, onnistunut action käynnistää createstate muutoksen?
      ConsoleHelper(
        "in reducer success, sent registration-questions succesfully!"
      );
      ConsoleHelper(action.payload.data);
      ConsoleHelper(action.payload.status);
      ConsoleHelper(
        "prev was (form/save) response data and then response statuscode"
      );
      if (action.payload.status === 200) {
        return loop(
          {
            ...state,
            initLoading: false,
            subEventFormId: action.payload.data.formId,
            subEventCreateState: {
              ...state.subEventCreateState,
              createRegistration: false,
              selectRegistration: false,
              eventPage: false,
              linkPage: true,
            },
            registrationState: {
              ...state.registrationState,
              pageMessages: {
                ...state.registrationState.pageMessages,
                pageId: action.payload.data.pageId,
              },
              pageStyling: {
                ...state.registrationState.pageStyling,
                styleId: action.payload.data.styleId,
              },
              link: {
                ...state.registrationState.link,
                linkId: action.payload.data.linkId,
                linkPrefix: action.payload.data.linkPrefix,
                linkSuggestion: action.payload.data.linkSuggestion,
              },
            },
          },
          Cmd.run(historyService.goto, {
            args: [`/events/${state.eventId}/subevents/${state.subEventId}`],
          })
        );
      } else {
        return { ...state, initLoading: false };
      }

    case getType(getParticipantDetails.request):
      return loop(
        { ...state, initLoading: true },
        Cmd.run(eventService.getParticipantDetails, {
          successActionCreator: getParticipantDetails.success,
          failActionCreator: getParticipantDetails.failure,
          args: [action.payload.subEventId, action.payload.uuid, state.eventId],
        })
      );
    case getType(getParticipantDetails.failure):
      return { ...state, initLoading: false };

    case getType(getParticipantDetails.success):
      ConsoleHelper("in reducer success, got participant-details succesfully!");
      ConsoleHelper(action.payload);
      return {
        ...state,
        initLoading: false,
        registrationState: action.payload.data.registrationState,
      };

    //post linkform
    case getType(postLinkForm.request):
      return loop(
        { ...state, initLoading: true },
        Cmd.run(eventService.postFormLink, {
          successActionCreator: postLinkForm.success,
          failActionCreator: postLinkForm.failure,
          args: [action.payload],
        })
      );

    case getType(postLinkForm.success):
      ConsoleHelper("posted form-link succesfully");
      ConsoleHelper(action.payload.data);
      if (action.payload.status === 200) {
        return {
          ...state,
          initLoading: false,
          subEventState: action.payload.data.subEventState,
          subEventCreateState: {
            ...state.subEventCreateState,
            eventPage: true,
            linkPage: false,
          },
          registrationState: {
            ...state.registrationState,
            link: {
              ...state.registrationState.link,
              link: action.payload.data.subEventLink,
            },
          },
        };
      } else if (action.payload.status === 206) {
        ConsoleHelper("tämä tulee jos linkki on jo olemassa!");
        return { ...state, initLoading: false };
      } else {
        ConsoleHelper("could not post link");
        ConsoleHelper(action.payload.status);
        return { ...state, initLoading: false };
      }

    case getType(postLinkForm.failure):
      ConsoleHelper("failed for some reason :(");
      return { ...state, initLoading: false };

    //get link suggestion
    case getType(getLinkSuggestion.request):
      return loop(
        { ...state, initLoading: true },
        Cmd.run(eventService.getLinkSuggestion, {
          successActionCreator: getLinkSuggestion.success,
          failActionCreator: getLinkSuggestion.failure,
        })
      );

    case getType(getLinkSuggestion.success):
      ConsoleHelper("got link suggestion");
      if (action.payload.status === 200) {
        return {
          ...state,
          initLoading: false,
          registrationState: {
            ...state.registrationState,
            link: {
              ...state.registrationState.link,
              linkId: action.payload.data.linkId,
              linkPrefix: action.payload.data.linkPrefix,
              linkSuggestion: action.payload.data.linkSuggestion,
            },
          },
        };
      } else {
        ConsoleHelper("could not get link suggestion");
        ConsoleHelper(action.payload.status);
        return { ...state, initLoading: false };
      }

    case getType(getLinkSuggestion.failure):
      ConsoleHelper("failed for some reason :(");
      return { ...state, initLoading: false };

    //synchronous changes in state
    case getType(changeCreateState):
      return {
        ...state,
        subEventCreateState: {
          ...state.subEventCreateState,
          [action.payload.key]: action.payload.value,
        },
      };
    case getType(changeRegistrationInfo):
      return {
        ...state,
        registrationState: {
          ...state.registrationState,
          subEventInfo: {
            ...state.registrationState.subEventInfo,
            [action.payload.nestedKey]: {
              ...state.registrationState.subEventInfo[action.payload.nestedKey],
              [action.payload.key]: action.payload.value,
            },
          },
        },
      };

    case getType(changePageStyling):
      return {
        ...state,
        registrationState: {
          ...state.registrationState,
          [action.payload.key]: {
            ...state.registrationState[action.payload.key],
            [action.payload.nestedKey]: action.payload.value,
          },
        },
      };

    case getType(updateRegistrationInfo):
      return {
        ...state,
        registrationState: {
          ...state.registrationState,
          subEventInfo: {
            ...state.registrationState.subEventInfo,
            [action.payload.key]: action.payload.value,
          },
        },
      };

    case getType(changeRegistrationInfoDate):
      return {
        ...state,
        registrationState: {
          ...state.registrationState,
          subEventInfo: {
            ...state.registrationState.subEventInfo,
            [action.payload.key]: action.payload.value
              ? action.payload.value.toISOString()
              : null,
          },
        },
      };
    case getType(setRegistrationQuestions):
      return {
        ...state,
        registrationState: {
          ...state.registrationState,
          registrationQuestions: action.payload,
        },
      };

    case getType(setEventDetails):
      return {
        ...state,
        eventDetails: action.payload.details,
        eventPage: {
          ...state.eventPage,
          subEventFilter: action.payload.subEventId
            ? action.payload.subEventId
            : null,
        },
      };

    default:
      return state;
  }
};

export function getEventState(state): EventState {
  return state.eventState;
}

export function getRegistrationStylingData(
  state
): { backgroundColor: string; pageHeader: string } {
  return {
    backgroundColor:
      state.eventState.registrationState.pageStyling.backgroundColor,
    pageHeader: state.eventState.registrationState.pageMessages.pageHeader,
  };
}

export type RegistrationQuestionsData = {
  state: draggableFormItems;
  dbKeys: DbKeyValues[];
  mailKeys: MailKeyValues[];
  options: { id: string; name: string }[];
  amountOptions: { id: string; name: string }[];
  itemsTable: { [key: string]: any };
};
export function getRegistrationFormItems(state): RegistrationQuestionsData {
  const formItems = state.eventState.registrationState.registrationQuestions;
  const dbKeys = state.eventState.registrationState.dbKeys
    ? state.eventState.registrationState.dbKeys.dbKeys
    : [];
  const mailKeys = state.eventState.registrationState.dbKeys
    ? state.eventState.registrationState.dbKeys.mailKeys
    : [];
  const options = state.eventState.registrationState.registrationQuestions.items.map(
    (item) => {
      return { id: item.id, name: item.question };
    }
  );
  const amountOptions = state.eventState.registrationState.registrationQuestions.items
    .filter((item) => item.type === "number")
    .map((item) => {
      return {
        id: item.id,
        name: item.question,
      };
    });
  const itemsTable = arrayToObject(
    state.eventState.registrationState.registrationQuestions.items,
    "id"
  );
  return {
    state: formItems,
    dbKeys,
    options,
    amountOptions,
    itemsTable,
    mailKeys,
  };
}

export function getLinkPageData(
  state
): {
  linkId: string;
  linkPrefix: string;
  linkSuggestion: string;
  subEventId: string;
} {
  return {
    linkId: state.eventState.registrationState.link.linkId,
    linkPrefix: state.eventState.registrationState.link.linkPrefix,
    linkSuggestion: state.eventState.registrationState.link.linkSuggestion,
    subEventId: state.eventState.subEventId,
  };
}

export type EventParticipantTableData = {
  table: TableParticipant[];
  startingTableHeaders: string[];
  participants: eventParticipant[];
  event: eventObject;
  initLoading: boolean;
};
export function selectEventParticipantTableData(
  state,
  eventId
): EventParticipantTableData {
  const mainEvent = state.listEventsState.events.find(
    (e) => e.eventId === eventId
  );
  const initLoading = checkLoading([
    state.participantState.initLoading,
    state.eventState.initLoading,
    state.listEventsState.initLoading,
  ]);
  const empty = { eventId: null, subEvents: [] } as eventObject;
  const table = state.participantState.participantsFormatted;
  const participants = state.participantState.participants;
  const event = mainEvent ? mainEvent : empty;
  const startingTableHeaders =
    table.length > 0
      ? getParticipantTableStartingHeaders(participants, table)
      : [];
  return {
    table,
    participants,
    event,
    startingTableHeaders,
    initLoading,
  };
}

export type ValidationDbKey = {
  name: string;
  additionalMessages: string[];
  key: string;
};

export type ValidationMessage = {
  message: string;
  variables: {
    [key: string]: string;
  };
};

export type ValidationError = {
  error: string;
  additionalMessages: ValidationMessage[];
};

export type RegistrationValidationData = {
  groupRegistration: boolean;
  missingRequiredDatabaseFields: ValidationDbKey[];
  missingRequiredEmailFields: MailKeyValues[];
  missingReservationQuestion: boolean;
  hideValidationErrors: ValidationError[];
  repeatableValidationErrors: ValidationError[];
  dbFieldValidationErrors: ValidationError[];
};
export function getRegistrationValidationData(
  state
): RegistrationValidationData {
  const items = state.formState.items.previewRegistrationForm;
  const groupRegistration =
    Number(
      state.eventState.registrationState.subEventInfo.subEventMaxGroupSize
    ) === 0
      ? false
      : true;
  const requiredDbFields = state.eventState.registrationState.dbKeys.dbKeys.filter(
    (key) => key.required
  );
  const questionsWithDbFields = items
    .filter((item) => item.dbKeys)
    .map((item) => item.dbKeys);
  const requiredEmailFields = state.eventState.registrationState.dbKeys.mailKeys.filter(
    (key) => key.groupRequired
  );
  const questionsWithEmailFields = items
    .filter((item) => item.mailKeys)
    .map((item) => item.mailKeys);
  const missingRequiredDatabaseFields = findMissingRequiredFields(
    questionsWithDbFields,
    requiredDbFields,
    groupRegistration
  );
  const missingRequiredEmailFields = groupRegistration
    ? findMissingRequiredEmailFields(
        questionsWithEmailFields,
        requiredEmailFields
      )
    : [];
  const missingReservationQuestion = groupRegistration
    ? !findAndValidateReservationQuestion(items)
    : false;
  const hideQuestions = items.filter((item) => item.hide);
  const hideValidationErrors = validateHideQuestions(items, hideQuestions);
  const repeatQuestions = items.filter((item) => item.repeatable);
  const repeatableValidationErrors = validateRepeatQuestions(
    items,
    repeatQuestions
  );
  const dbFieldQuestions = items.filter((item) => item.dbKeys);
  const dbFieldValidationErrors = groupRegistration
    ? validateDbFieldQuestions(dbFieldQuestions)
    : [];
  return {
    groupRegistration,
    missingRequiredDatabaseFields,
    missingRequiredEmailFields,
    missingReservationQuestion,
    hideValidationErrors,
    repeatableValidationErrors,
    dbFieldValidationErrors,
  };
}

function validateDbFieldQuestions(dbQuestions: formInputInfo[]) {
  const result = dbQuestions.map((dbQuestion) => checkDbQuestion(dbQuestion));
  return result.filter((item) => item.error !== null);
}

function checkDbQuestion(question: formInputInfo) {
  const isAPersonQuestion = question.person ? question.person : false;
  const isNotPersonError = !isAPersonQuestion
    ? [
        {
          message: "Validation.DbField.NonPerson",
          variables: {
            key: question.id,
          },
        },
      ]
    : [];
  return {
    error: !isAPersonQuestion ? question.id : null,
    additionalMessages: isNotPersonError,
  };
}

function validateRepeatQuestions(
  items: formInputInfo[],
  repeatQuestions: formInputInfo[]
) {
  const result = repeatQuestions.map((repeatQuestion) =>
    checkRepeatQuestion(repeatQuestion, items)
  );
  return result.filter((item) => item.error !== null);
}

function checkRepeatQuestion(question: formInputInfo, items: formInputInfo[]) {
  const keyExist = items.find((item) => item.id === question.repeatable.key);
  const valueCanBeOfType =
    keyExist && keyExist.options
      ? keyExist.options.includes(question.repeatable.value)
      : false;
  const amountKeyExist = items.find(
    (item) => item.id === question.repeatable.amount
  );
  const amountIsNumberType = amountKeyExist && amountKeyExist.type === "number";
  const afterKeyExist = items.find(
    (item) => item.id === question.repeatable.after
  );
  const conditionsToCheck = [
    keyExist !== undefined,
    valueCanBeOfType,
    amountKeyExist !== undefined,
    amountIsNumberType,
    afterKeyExist !== undefined,
  ];
  const keyNotExistError = !keyExist
    ? [
        {
          message: "Validation.Repeat.Key",
          variables: {
            key: question.repeatable.key,
          },
        },
      ]
    : [];
  const valueError = !valueCanBeOfType
    ? [
        {
          message: "Validation.Repeat.Value",
          variables: {
            key: question.repeatable.key,
            value: question.repeatable.value,
          },
        },
      ]
    : [];
  const amountKeyNotExistError = !amountKeyExist
    ? [
        {
          message: "Validation.Repeat.Amount.Key",
          variables: {
            key: question.repeatable.amount,
          },
        },
      ]
    : [];
  const amountIsNumberTypeError = !amountIsNumberType
    ? [
        {
          message: "Validation.Repeat.Amount.Type",
          variables: {
            key: question.repeatable.amount,
          },
        },
      ]
    : [];
  const afterKeyNotExistError = !afterKeyExist
    ? [
        {
          message: "Validation.Repeat.After",
          variables: {
            key: question.repeatable.after,
          },
        },
      ]
    : [];
  return {
    error: conditionsToCheck.includes(false) ? question.id : null,
    additionalMessages: keyNotExistError.concat(
      valueError,
      amountKeyNotExistError,
      amountIsNumberTypeError,
      afterKeyNotExistError
    ),
  };
}

function validateHideQuestions(
  items: formInputInfo[],
  hideQuestions: formInputInfo[]
) {
  const result = hideQuestions.map((hideQuestion) =>
    checkHideQuestion(hideQuestion, items)
  );
  return result.filter((item) => item.error !== null);
}

function checkHideQuestion(question: formInputInfo, items: formInputInfo[]) {
  const keyExist = items.find((item) => item.id === question.hide.key);
  const valueCanBeOfType =
    keyExist && keyExist.options
      ? keyExist.options.includes(question.hide.value)
      : false;
  const hideKeyError = !keyExist
    ? [
        {
          message: "Validation.Hide.Key",
          variables: {
            key: question.hide.key,
          },
        },
      ]
    : [];
  const hideErrorValue = !valueCanBeOfType
    ? [
        {
          message: "Validation.Hide.Value",
          variables: {
            value: question.hide.value,
            key: question.hide.key,
          },
        },
      ]
    : [];
  const conditionsToCheck = [keyExist !== undefined, valueCanBeOfType];
  return {
    error: conditionsToCheck.includes(false)
      ? question.id
      : null
      ? question.id
      : null,
    additionalMessages: hideKeyError.concat(hideErrorValue),
  };
}

function findAndValidateReservationQuestion(items: formInputInfo[]) {
  return items.find((item) => item.reservation && item.type === "number");
}

function findMissingRequiredEmailFields(
  items: MailKey[],
  requiredEmailFields: MailKeyValues[]
) {
  const result = requiredEmailFields.filter(
    (emailField) => !checkIfEmailKeyFound(emailField, items)
  );
  return result;
}

function checkIfEmailKeyFound(key: MailKeyValues, items: MailKey[]) {
  return items.find((item) => item.key === key.internalDbValue);
}

function findMissingRequiredFields(
  items: DbKey[],
  requiredDbFields: DbKeyValues[],
  group: boolean
) {
  const result = requiredDbFields.filter(
    (dbField) => !checkIfKeyFound(dbField, items)
  );
  return result.map((item) => {
    return {
      name: item.fieldName,
      key: item.internalDbValue,
      additionalMessages: group ? ["Validation.Group.Person"] : [],
    };
  });
}

function checkIfKeyFound(key: DbKeyValues, items: DbKey[]) {
  return items.find((item) => item.key === key.internalDbValue);
}

export type EventIds = {
  eventId: string;
  eventName: string;
  subEventId: string;
  subEventName: string;
};
export function selectEventIds(state): EventIds {
  const eventId = state.eventState.eventId;
  const eventName = state.eventState.eventName;
  const subEventId = state.eventState.subEventId;
  const subEventName = state.eventState.subEventName;
  return { eventId, subEventId, eventName, subEventName };
}

export function selectHasSubEventForm(state): boolean {
  return state.eventState.subEventFormId === "0" ? false : true;
}

export type EventDataFetched = {
  eventListFetched: boolean;
  eventDetailsFetched: boolean;
};
export function selectDataFetchedFlags(state): EventDataFetched {
  const eventListFetched = state.listEventsState.eventsFetched;
  const eventDetailsFetched = state.eventState.eventFetched;
  return { eventListFetched, eventDetailsFetched };
}
